// These were the locales supported by OnePay as of October 28, 2024
const onePayLocales = ['de_DE', 'en_US', 'es_ES', 'fr_FR', 'it_IT', 'ja_JP', 'ko_KR', 'pt_BR', 'zh_CN']

// These are the locales supported by GotoAdmin
export const gotoAdminLocales = [...onePayLocales, 'en_GB']

export const getOnePayLocaleFromContentLanguage = (contentLanguage: string) => {
    // Find the onepay locale that starts with the two-letter content language, or fallback to 'en_US'
    return onePayLocales.find((onePayLocale) => onePayLocale.startsWith(contentLanguage)) || 'en_US'
}
